// src/components/study/CrcNamesButton.js
//
// "CRC names" button in the Admin Dashboard's filter bar, beside the study
// count (UI revamp): site admins only (owner, company admin, site admin);
// everyone else sees nothing. Opens the CRC names pop-up (CrcNamesModal).

import { useState } from "react";
import { Users } from "lucide-react";
import useSiteAdmin from "../sourcex/useSiteAdmin";
import CrcNamesModal from "./CrcNamesModal";

export default function CrcNamesButton({ studies }) {
  const isAdmin = useSiteAdmin();
  const [open, setOpen] = useState(false);
  if (!isAdmin) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl bg-white/[0.04] border border-white/10 hover:bg-white/[0.08] text-xs text-slate-200 transition shrink-0"
      >
        <Users className="w-3.5 h-3.5" />
        CRC names
      </button>
      {open && <CrcNamesModal studies={studies} onClose={() => setOpen(false)} />}
    </>
  );
}
